<template>
  <div class="side_bar_wrapper col-lg-3 d-none d-lg-block">
    <div class="side_bar">
      <div class="p-xl-4 p-lg-3 p-3 mt-lg-5">
        <h5>Hi, Welcome!</h5>
        <p>Answer a few quick questions, and we’ll connect with you.</p>
        <hr style="border: 1px solid black;">

        <div class="steps_menu mt-4">
          <div class="step" :class="{ completed: currentStep > 1, active: currentStep === 1 }">
            <div class="circle">1</div>
            <div class="text" :class="{ completed: currentStep > 1 }">Applicant Details</div>
          </div>
          <div class="step" :class="{ completed: currentStep > 2, active: currentStep === 2 }">
            <div class="circle">2</div>
            <div class="text">Select Slot</div>
          </div>
          <div class="step" :class="{ completed: currentStep > 3, active: currentStep === 3 }">
            <div class="circle">3</div>
            <div class="text">Invoice Summary</div>
          </div>
          <div class="step" :class="{ completed: currentStep > 4, active: currentStep === 4 }">
            <div class="circle">4</div>
            <div class="text">Payment</div>
          </div>
          <div class="step" :class="{ completed: currentStep > 5, active: currentStep === 5 }">
            <div class="circle">5</div>
            <div class="text">Documents Upload</div>
          </div>
          <p class="mt-4">If you complete 5 Steps, Get an Appointment.</p>
        </div>
      </div>

      <hr style="height: 5px !important; background-color: #000; border: none;" v-if="hasInstructions && currentStep === 5">

      <div v-if="hasInstructions && currentStep === 5" class="instructions-card shadow-sm">
        <div 
          ref="instructionContainer" 
          v-html="savedFormData.data.entity_details[0].custom_text" 
          class="instruction-content"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['currentStep'],
  data() {
    return {
      savedFormData: null,
      showFullInstructions: false
    };
  },
  computed: {
    hasInstructions() {
      const customText = this.savedFormData?.data?.entity_details?.[0]?.custom_text;
      //console.log('customText :', customText);
      ///console.log('currentStep 1:', this.currentStep);
      return customText && customText.trim() !== '';
    }
  },
  watch: {
    currentStep(newValue) {
      if (newValue === 5) {
        const saved = localStorage.getItem('bookingFormData');
        this.savedFormData = saved ? JSON.parse(saved) : null;
      }
    }
  },
  mounted() {
    const saved = localStorage.getItem('bookingFormData');
    this.savedFormData = saved ? JSON.parse(saved) : null;
  },
  methods: {
    toggleInstructions() {
      this.showFullInstructions = !this.showFullInstructions;
    }
  },
};
</script>
<style scoped>
.side_bar_wrapper {
  padding: 0;
  position: relative;
}

.side_bar {
  background-color: rgba(252, 243, 244, 1);
  height: 130vh !important;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0,0,0,0.05);
}

.instructions-card {
  background: rgba(252, 243, 244, 1);
  padding: 1rem;
  /* border-top: 1px solid #ddd; */
  display: block !important;
  max-height: 400vh !important;
  overflow-y: auto !important; /* scroll vertically if content exceeds height */
  overflow-x: hidden;
}

/*  For WebKit browsers (Chrome, Safari, Edge) */
.instructions-card::-webkit-scrollbar {
  width: 8px; /* scrollbar width */
}

.instructions-card::-webkit-scrollbar-thumb {
  background-color: rgb(235, 231, 231);
  border-radius: 4px;
}

.instructions-card::-webkit-scrollbar-thumb:hover {
  background-color: rgba(252, 243, 244, 1);
}

.instructions-card::-webkit-scrollbar-track {
  background: rgba(252, 243, 244, 1);
}

@media (max-width: 991px) {
  .side_bar_wrapper {
    display: none;
  }
}

</style>
